export default "__VITE_ASSET__d5tjde7v__"